export default "Éco-PTZ 2026 — Prêt à taux zéro jusqu'à 50 000 € | Solution Éco France";
